import { render, staticRenderFns } from "./TopicDropdown.vue?vue&type=template&id=3bb50d5a"
import script from "./TopicDropdown.vue?vue&type=script&lang=js"
export * from "./TopicDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports